import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ViewMoreBtn from "../../components/ViewMoreBtn";
import DataTable from "react-data-table-component";
import { useLocation, useNavigate } from "react-router-dom";
import { LuFilter } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getPayments } from "../../../../redux/slices/paymentSlice";
import DeleteModal from "../../components/DeleteModal";

const Payment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  // Orders table states
  const [orderSearchText, setOrderSearchText] = useState("");
  const [orderCategory, setOrderCategory] = useState("");
  const [orderResetPaginationToggle, setOrderResetPaginationToggle] = useState(false);

  // Discount Packages table states
  const [discountSearchText, setDiscountSearchText] = useState("");
  const [discountCategory, setDiscountCategory] = useState("");
  const [discountResetPaginationToggle, setDiscountResetPaginationToggle] = useState(false);

  // Gift Certificates table states
  const [giftSearchText, setGiftSearchText] = useState("");
  const [giftCategory, setGiftCategory] = useState("");
  const [giftResetPaginationToggle, setGiftResetPaginationToggle] = useState(false);

  const [deleteId, setDeleteId] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const { payments, refetch } = useSelector((state) => state.paymentSlice);

  const prevProps = useRef({ refetch }).current;

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const hasRestoredScroll = useRef(false);
  const locationState = useLocation();

  useEffect(() => {
    return () => {
      hasRestoredScroll.current = false;
    };
  }, []);

  useLayoutEffect(() => {
    if (
      locationState?.state?.scrollY !== undefined &&
      payments.length > 0
    ) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            window.scrollTo({
              top: locationState.state.scrollY,
              behavior: "auto",
            });
          }, 150);
        });
      });
    }
  }, [payments, locationState]);


  // useLayoutEffect(() => {
  //   if (
  //     !hasRestoredScroll.current &&
  //     locationState?.state?.scrollY !== undefined &&
  //     services.length > 0
  //   ) {
  //     // wait for DataTable pagination + DOM paint
  //     requestAnimationFrame(() => {
  //       requestAnimationFrame(() => {
  //         setTimeout(() => {
  //           window.scrollTo({
  //             top: locationState.state.scrollY,
  //             behavior: "auto",
  //           });
  //           hasRestoredScroll.current = true;
  //         }, 50);
  //       });
  //     });
  //   }
  // }, [services]);


  useEffect(() => {
    if (locationState?.state?.pagination) {
      const { page, perPage } = locationState.state.pagination;
      setCurrentPage(page);
      setRowsPerPage(perPage);
    }
  }, []);


  useEffect(() => {
    if (prevProps.refetch != refetch) {
      dispatch(getPayments(setIsLoading));
    }
    return () => {
      prevProps.refetch = refetch;
    };
  }, [refetch]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getPayments(setIsLoading));
  }, []);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  // Separate payments into three categories
  const orderPayments = payments.filter((payment) => payment.orderCode);
  const discountPayments = payments.filter((payment) => payment.discountBookingId && !payment.orderCode);
  const giftPayments = payments.filter((payment) => payment.giftCertificateId && !payment.orderCode && !payment.discountBookingId);

  // Common columns structure
  const getColumns = (referenceFieldName) => [
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
    },
    {
      name: "Customer Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: referenceFieldName,
      selector: (row) => row.referenceId,
      sortable: true,
    },
    {
      name: "Transaction-Id",
      selector: (row) => row.transactionId,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => row.action,
    },
  ];

  // Transform payment data for orders
  const orderData = orderPayments.map((payment) => {
    const isDeleted = payment.deleted;
    return {
      id: payment._id,
      name: (
        <span
          style={{ color: "#be9528", cursor: "pointer" }}
          onClick={() => navigate(`/user/${payment?.createdBy?._id}`)}
        >
          {payment?.createdBy?.fullName}
        </span>
      ),
      referenceId: (
        <span
          style={{ color: "#be9528", cursor: "pointer" }}
          onClick={() => navigate(`/bookings/program/${payment.orderCode}`)}
        >
          {payment.orderCode}
        </span>
      ),
      transactionId: payment?.transactionId,
      amount: `${payment.amount} ${payment.currency}`,
      status: (
        <label
          className={
            payment.paymentStatus == "failure"
              ? "badge badge-danger"
              : "badge badge-success"
          }
        >
          {payment.paymentStatus == "failure" ? "Failed" : "Success"}
        </label>
      ),
      createdAt: new Date(payment.createdAt)
        .toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-"),
      action: (
        <div
          className="d-flex align-items-center justify-content-start"
          style={{
            gap: "14px",
            minWidth: "180px",
          }}>
          <AiOutlineDelete
            size={19}
            onClick={
              !isDeleted
                ? () => {
                  setDeleteId(payment._id);
                  setDeleteModal(true);
                }
                : null
            }
            style={{
              cursor: isDeleted ? "not-allowed" : "pointer",
              opacity: isDeleted ? 0.5 : 1,
            }}
          />
          <div className="d-flex">
            <ViewMoreBtn
              redirectUrl={{
                pathname: `/payment/${payment._id}`,
                state: {
                  pagination: {
                    page: currentPage,
                    perPage: rowsPerPage,
                  },
                  scrollY: window.scrollY,
                },
              }}
            />
          </div>
        </div>
      ),
    };
  });

  // Transform payment data for discount packages
  const discountData = discountPayments.map((payment) => {
    const isDeleted = payment.deleted;
    return {
      id: payment._id,
      name: (
        <span
          style={{ color: "#be9528", cursor: "pointer" }}
          onClick={() => navigate(`/user/${payment?.createdBy?._id}`)}
        >
          {payment?.createdBy?.fullName}
        </span>
      ),
      referenceId: (
        <span
          style={{ color: "#be9528", cursor: "pointer" }}
          onClick={() => navigate(`/bookings/discount/${payment.discountBookingId}`)}
        >
          {payment.discountBookingId}
        </span>
      ),
      transactionId: payment?.transactionId,
      amount: `${payment.amount} ${payment.currency}`,
      status: (
        <label
          className={
            payment.paymentStatus == "failure"
              ? "badge badge-danger"
              : "badge badge-success"
          }
        >
          {payment.paymentStatus == "failure" ? "Failed" : "Success"}
        </label>
      ),
      createdAt: new Date(payment.createdAt)
        .toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-"),
      action: (
        <div
          className="d-flex align-items-center justify-content-start"
          style={{
            gap: "14px",
            minWidth: "180px",
          }}>
          <AiOutlineDelete
            size={19}
            onClick={
              !isDeleted
                ? () => {
                  setDeleteId(payment._id);
                  setDeleteModal(true);
                }
                : null
            }
            style={{
              cursor: isDeleted ? "not-allowed" : "pointer",
              opacity: isDeleted ? 0.5 : 1,
            }}
          />
          <div className="d-flex">
            <ViewMoreBtn
              redirectUrl={{
                pathname: `/payment/${payment._id}`,
                state: {
                  pagination: {
                    page: currentPage,
                    perPage: rowsPerPage,
                  },
                  scrollY: window.scrollY,
                },
              }}
            />
          </div>
        </div>
      ),
    };
  });

  // Transform payment data for gift certificates
  const giftData = giftPayments.map((payment) => {
    const isDeleted = payment.deleted;
    return {
      id: payment._id,
      name: (
        <span
          style={{ color: "#be9528", cursor: "pointer" }}
          onClick={() => navigate(`/user/${payment?.createdBy?._id}`)}
        >
          {payment?.createdBy?.fullName}
        </span>
      ),
      referenceId: (
        <span
          style={{ color: "#be9528", cursor: "pointer" }}
          onClick={() => navigate(`/gift/${payment.couponId}/details`)}
        >
          {payment.couponId}
        </span>
      ),
      transactionId: payment?.transactionId,
      amount: `${payment.amount} ${payment.currency}`,
      status: (
        <label
          className={
            payment.paymentStatus == "failure"
              ? "badge badge-danger"
              : "badge badge-success"
          }
        >
          {payment.paymentStatus == "failure" ? "Failed" : "Success"}
        </label>
      ),
      createdAt: new Date(payment.createdAt)
        .toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-"),
      action: (
        <div
          className="d-flex align-items-center justify-content-start"
          style={{
            gap: "14px",
            minWidth: "180px",
          }}>
          <AiOutlineDelete
            size={19}
            onClick={
              !isDeleted
                ? () => {
                  setDeleteId(payment._id);
                  setDeleteModal(true);
                }
                : null
            }
            style={{
              cursor: isDeleted ? "not-allowed" : "pointer",
              opacity: isDeleted ? 0.5 : 1,
            }}
          />
          <div className="d-flex">
            <ViewMoreBtn
              redirectUrl={{
                pathname: `/payment/${payment._id}`,
                state: {
                  pagination: {
                    page: currentPage,
                    perPage: rowsPerPage,
                  },
                  scrollY: window.scrollY,
                },
              }}
            />
          </div>
        </div>
      ),
    };
  });

  // Filter functions
  const filterData = (data, searchText, category) => {
    return data.filter((item) => {
      const name =
        typeof item.name.props.children === "string"
          ? item.name.props.children.toLowerCase()
          : "";

      return (
        name.includes(searchText.toLowerCase()) &&
        (category ? item.status.props.children === category : true)
      );
    });
  };

  const filteredOrderData = filterData(orderData, orderSearchText, orderCategory);
  const filteredDiscountData = filterData(discountData, discountSearchText, discountCategory);
  const filteredGiftData = filterData(giftData, giftSearchText, giftCategory);

  // Search handlers
  const handleOrderSearch = (value) => {
    setOrderSearchText(value);
    setOrderResetPaginationToggle(!orderResetPaginationToggle);
  };

  const handleDiscountSearch = (value) => {
    setDiscountSearchText(value);
    setDiscountResetPaginationToggle(!discountResetPaginationToggle);
  };

  const handleGiftSearch = (value) => {
    setGiftSearchText(value);
    setGiftResetPaginationToggle(!giftResetPaginationToggle);
  };

  // Category handlers
  const handleOrderCategoryChange = (value) => {
    setOrderCategory(value);
    setOrderResetPaginationToggle(!orderResetPaginationToggle);
  };

  const handleDiscountCategoryChange = (value) => {
    setDiscountCategory(value);
    setDiscountResetPaginationToggle(!discountResetPaginationToggle);
  };

  const handleGiftCategoryChange = (value) => {
    setGiftCategory(value);
    setGiftResetPaginationToggle(!giftResetPaginationToggle);
  };

  // CSV export functions
  const convertToCsvString = (data) => {
    if (data.length === 0) return "";
    const rows = [];
    const headers = ["Created At", "Customer Name", "Reference ID", "Transaction ID", "Amount", "Status"];
    rows.push(headers.join(","));

    data.forEach((item) => {
      const name = typeof item.name.props.children === "string" ? item.name.props.children : "";
      const referenceId = typeof item.referenceId.props.children === "string" ? item.referenceId.props.children : "";
      const status = typeof item.status.props.children === "string" ? item.status.props.children : "";
      const values = [
        item.createdAt,
        name,
        referenceId,
        item.transactionId,
        item.amount,
        status
      ];
      rows.push(values.join(","));
    });

    return rows.join("\n");
  };

  const exportOrdersToCsv = () => {
    const csvContent = convertToCsvString(filteredOrderData);
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "orders_payments.csv";
    link.click();
  };

  const exportDiscountsToCsv = () => {
    const csvContent = convertToCsvString(filteredDiscountData);
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "discount_packages_payments.csv";
    link.click();
  };

  const exportGiftsToCsv = () => {
    const csvContent = convertToCsvString(filteredGiftData);
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "gift_certificates_payments.csv";
    link.click();
  };

  // Render table component
  const renderTable = (title, columns, data, searchText, category, handleSearch, handleCategoryChange, exportToCsv, resetPaginationToggle) => (
    <div className="row mb-4">
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body py-4">
            <DataTable
              title={<h6 className="card-title">{title}</h6>}
              columns={columns}
              data={data}
              pagination
              paginationPerPage={rowsPerPage}
              paginationDefaultPage={currentPage}
              paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
              onChangePage={(page) => setCurrentPage(page)}
              onChangeRowsPerPage={(newPerPage, page) => {
                setRowsPerPage(newPerPage);
                setCurrentPage(page);
              }}
              highlightOnHover
              pointerOnHover
              subHeader
              subHeaderAlign="left"
              subHeaderComponent={
                <>
                  <Row className="mb-3 w-100">
                    <Col
                      md={8}
                      className="d-flex align-items-start flex-column gap-2"
                    >
                      <span className="d-flex align-items-center gap-2 me-3 filterby_label">
                        <LuFilter />
                        Filter By :
                      </span>
                      <div className="table_filter">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by name"
                          value={searchText}
                          onChange={(e) => handleSearch(e.target.value)}
                        />
                        <select
                          className="form-control h-54px w-auto"
                          value={category}
                          onChange={(e) => handleCategoryChange(e.target.value)}
                        >
                          <option selected value="">
                            Status
                          </option>
                          <option value="Success">Success</option>
                          <option value="Failed">Failed</option>
                        </select>
                      </div>
                    </Col>
                    <Col md={4} className="d-flex align-items-end">
                      <button
                        className="btn_primary_outline_sm ms-auto"
                        disabled={!data.length}
                        onClick={exportToCsv}
                      >
                        Export CSV
                      </button>
                    </Col>
                  </Row>
                </>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {isLoading ? (
        <div className="w-100 d-flex">
          <div className="spinner-border text-primary mx-auto" role="status"></div>
        </div>
      ) : (
        <>
          <div>
            <div className="page-header">
              <h3 className="page-title">Payments</h3>
            </div>

            {/* Orders Payments Table */}
            {renderTable(
              `Orders Payments (${filteredOrderData.length})`,
              getColumns("Order-Id"),
              filteredOrderData,
              orderSearchText,
              orderCategory,
              handleOrderSearch,
              handleOrderCategoryChange,
              exportOrdersToCsv,
              orderResetPaginationToggle
            )}

            {/* Discount Packages Payments Table */}
            {renderTable(
              `Discount Packages Payments (${filteredDiscountData.length})`,
              getColumns("Discount Booking-Id"),
              filteredDiscountData,
              discountSearchText,
              discountCategory,
              handleDiscountSearch,
              handleDiscountCategoryChange,
              exportDiscountsToCsv,
              discountResetPaginationToggle
            )}

            {/* Gift Certificates Payments Table */}
            {renderTable(
              `Gift Certificates Payments (${filteredGiftData.length})`,
              getColumns("Gift Certificate-Id"),
              filteredGiftData,
              giftSearchText,
              giftCategory,
              handleGiftSearch,
              handleGiftCategoryChange,
              exportGiftsToCsv,
              giftResetPaginationToggle
            )}
          </div>
          <DeleteModal
            forPayment
            deleteId={deleteId}
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
          />
        </>
      )}
    </>
  );
};

export default Payment;
